import { Skeleton } from '@mui/material';
import React from 'react';
import { PunctualCourseDashboard } from '../../Objects/models/PunctualCourseDashboard';
import { TheadItem } from '../../Objects/interfaces/AppInterface';
// import Loader from '../../Utils/Loader';
// import { loader } from '../../Utils/Images';
import Pagination from './Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
// import Button from '@mui/material/Button';
import useTailwindBrand from '../../Theme/useTailwindBrand';



interface Props {
    data: PunctualCourseDashboard | any
    message?: any,
    bgImg?: string,
    dataThead?: TheadItem[]
    component?: any
    loading?: boolean
    // setLoading?: React.Dispatch<React.SetStateAction<boolean>>
    // totalPage?: number | undefined | any
    currentPage?: number | undefined
    paginate?: (pageNumber: number) => void
    pageLimit?: (limitNumber: number) => void
    // nextPage?: number | undefined
    // prevPage?: number | undefined
    totalItems?: number | undefined
    header?: any
    customImg?: any
    hidePage?: boolean
    // setCurrentPage?: any
    gardePage?: any 
}
const TableLayout = (props: Props) => {
    // const isUpdate = false
    const {classes} = useTailwindBrand()

    return (
        <div>
            <div className="relative space-y-8">
                {props.header}
                <div className={`${!props.data || props.data.length === 0 ? (props.hidePage ? '' : (props.gardePage ? '' : 'h-[470px]')) : ''} ${classes.fontFamily} overflow-x-auto `}>
                    {!props.data ?
                        <Skeleton variant="rectangular" width="100%" height="100%" /> :
                        props.data.length === 0 ?
                            <>
                                {
                                    props.gardePage ? props.gardePage :
                                        <div className="shadow-md border-2 rounded-md mx-auto h-full flex-col flex items-center md:gap-y-8 gap-y-4 py-8">
                                            <p className={`${props.hidePage ? 'lg:text-lg md:text-base text-sm px-2' : 'lg:text-xl md:text-lg text-base px-8'}  ${classes.fontFamily} ${classes.text} text-center mx-auto`}>
                                                {props.message}
                                            </p>
                                            <img
                                                src={props.bgImg}
                                                alt="En attente"
                                                className={`mx-auto ${props.customImg ?? 'h-[50%]'} lg:block hidden`}
                                            />
                                        </div>
                                }
                            </>
                            :
                            <>
                                <div className="overflow-x-auto">
                                    {props.loading ?
                                        <div className='h-[400px] mx-auto border shadow-md rounded-md lg:w-full'>
                                            <Backdrop
                                                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                                                open={props.loading}
                                            >
                                                <CircularProgress color="inherit" />
                                            </Backdrop>
                                        </div>
                                        :
                                        <table className={`w-full text-sm text-left ${classes.text} px-2 pb-1 border-separate border-spacing-y-1 shadow-md border-b-2 border-l-2 border-r-2  rounded-md`}>
                                            <thead className={`lg:text-sm text-xs ${classes.text} uppercase shadow-md /opacity-80 ${classes.background}`}>
                                                <tr className='shadow-md'>
                                                    {props?.dataThead?.map((data: TheadItem, index: number) => (
                                                        <th key={index} scope="col" className={`px-4 md:py-5 py-3 font-bold /text-white ${data.classThead}`}>
                                                            {data.title}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>{props.component}</tbody>
                                        </table>
                                    }
                                </div>
                                {!props.hidePage && <Pagination pageLimit={props.pageLimit} items={props.totalItems} onPageChange={props.paginate} currentPage={props.currentPage} />}
                            </>
                    }
                </div>
            </div>
        </div>
    );
};

export default TableLayout;